/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const REQUESTED_COMMENTARY = 'REQUESTED_COMMENTARY';
export const requestedCommentary = (commentaryType) => {
  return {
    type: REQUESTED_COMMENTARY,
    commentaryType
  };
};

export const RECEIVED_COMMENTARY = 'RECEIVED_COMMENTARY';
export const receivedCommentary = (commentary) => {
  return {
    type: RECEIVED_COMMENTARY,
    commentary
  };
};

export const ERROR_COMMENTARY = 'ERROR_COMMENTARY';
export const errorCommentary = (error, commentaryType) => {
  return {
    type: ERROR_COMMENTARY,
    error,
    commentaryType
  };
};

export const REQUESTED_ACTIVITY_WITH_COMMENTARY =
  'REQUESTED_ACTIVITY_WITH_COMMENTARY';
export const requestedActivityWithCommentary = () => {
  return {
    type: REQUESTED_ACTIVITY_WITH_COMMENTARY
  };
};

export const RECEIVED_ACTIVITY_WITH_COMMENTARY =
  'RECEIVED_ACTIVITY_WITH_COMMENTARY';
export const receivedActivityWithCommentary = () => {
  return {
    type: RECEIVED_ACTIVITY_WITH_COMMENTARY
  };
};

export const ERROR_ACTIVITY_WITH_COMMENTARY = 'ERROR_ACTIVITY_WITH_COMMENTARY';
export const errorActivityWithCommentary = (error) => {
  return {
    type: ERROR_ACTIVITY_WITH_COMMENTARY,
    error
  };
};

export const REQUESTED_GROWTH_WITH_COMMENTARY =
  'REQUESTED_GROWTH_WITH_COMMENTARY';
export const requestedGrowthWithCommentary = () => {
  return {
    type: REQUESTED_GROWTH_WITH_COMMENTARY
  };
};

export const RECEIVED_GROWTH_WITH_COMMENTARY =
  'RECEIVED_GROWTH_WITH_COMMENTARY';
export const receivedGrowthWithCommentary = () => {
  return {
    type: RECEIVED_GROWTH_WITH_COMMENTARY
  };
};

export const ERROR_GROWTH_WITH_COMMENTARY = 'ERROR_GROWTH_WITH_COMMENTARY';
export const errorGrowthWithCommentary = (error) => {
  return {
    type: ERROR_GROWTH_WITH_COMMENTARY,
    error
  };
};

export const REQUESTED_PERFORMANCE_WITH_COMMENTARY =
  'REQUESTED_PERFORMANCE_WITH_COMMENTARY';
export const requestedPerformanceWithCommentary = () => {
  return {
    type: REQUESTED_PERFORMANCE_WITH_COMMENTARY
  };
};

export const RECEIVED_PERFORMANCE_WITH_COMMENTARY =
  'RECEIVED_PERFORMANCE_WITH_COMMENTARY';
export const receivedPerformanceWithCommentary = () => {
  return {
    type: RECEIVED_PERFORMANCE_WITH_COMMENTARY
  };
};

export const ERROR_PERFORMANCE_WITH_COMMENTARY =
  'ERROR_PERFORMANCE_WITH_COMMENTARY';
export const errorPerformanceWithCommentary = (error) => {
  return {
    type: ERROR_PERFORMANCE_WITH_COMMENTARY,
    error
  };
};
